import { render, staticRenderFns } from "./SidebarBlock.vue?vue&type=template&id=8f85d47c&scoped=true&"
import script from "./SidebarBlock.vue?vue&type=script&lang=js&"
export * from "./SidebarBlock.vue?vue&type=script&lang=js&"
import style0 from "./SidebarBlock.vue?vue&type=style&index=0&id=8f85d47c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f85d47c",
  null
  
)

component.options.__file = "SidebarBlock.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAction } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
installComponents(component, {
  VIcon,
  VList,
  VListTile,
  VListTileAction,
  VListTileContent,
  VListTileTitle,
})
